import React from 'react';


const Tape = ({size}) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 124.3 93.5"
        style={{"enableBackground": "new 0 0 124.3 93.5", fill: "#000"}}
        height={size}
        className="tape-icon"
    >
    <g>
        <path className="dim-icons" d="M33.9,29.6c11.8,0,19.7-4,19.7-10.1c0-6-7.9-10.1-19.7-10.1s-19.7,4.1-19.7,10.1S22.1,29.6,33.9,29.6z
             M33.9,13.4c8.8,0,15.7,2.7,15.7,6.1c0,3.4-6.9,6.1-15.7,6.1s-15.7-2.7-15.7-6.1C18.2,16.1,25.1,13.4,33.9,13.4z"/>
        <path className="st0" d="M115,32.8H65.6V19.5c0-9.7-13.9-17.3-31.7-17.3C16.1,2.2,2.2,9.8,2.2,19.5v54.6c0,9.7,13.9,17.3,31.7,17.3H115
            c4,0,7.2-3.2,7.2-7.2V40C122.2,36.1,119,32.8,115,32.8z M54.3,32.8c2.9-1.3,5.4-2.9,7.2-4.8v4.8H54.3z M33.9,6.2
            c15,0,27.7,6.1,27.7,13.3S48.9,32.8,33.9,32.8S6.2,26.7,6.2,19.5S18.9,6.2,33.9,6.2z M118.2,84.2c0,1.8-1.4,3.2-3.2,3.2h-13.6V70.7
            c0-1.1-0.9-2-2-2s-2,0.9-2,2v16.7H91v-6.2c0-1.1-0.9-2-2-2s-2,0.9-2,2v6.2h-6.4V70.7c0-1.1-0.9-2-2-2s-2,0.9-2,2v16.7h-6.4v-6.2
            c0-1.1-0.9-2-2-2s-2,0.9-2,2v6.2h-6.4V70.7c0-1.1-0.9-2-2-2s-2,0.9-2,2v16.7h-6.4v-6.2c0-1.1-0.9-2-2-2s-2,0.9-2,2v6.2H39V70.7
            c0-1.1-0.9-2-2-2s-2,0.9-2,2v16.7h-1.1c-1.8,0-3.6-0.1-5.3-0.3v-6.4c0-1.1-0.9-2-2-2s-2,0.9-2,2v5.9c-2.3-0.4-4.4-1-6.4-1.6V67.7
            c0-1.1-0.9-2-2-2s-2,0.9-2,2v15.6c-4.9-2.4-8-5.7-8-9.3V28c5.4,5.3,15.6,8.8,27.7,8.8H115c1.8,0,3.2,1.4,3.2,3.2V84.2z"/>
    </g>
    </svg>
);

const Bed = ({size}) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 374 374"
        style={{"enableBackground":"new 0 0 374 374", fill: "#2A2A2A"}}
        className="bed-icon"
    >
    <g>
        <g>
            <path className="dim-icons" d="M337.6,158.6v-0.4V97.8c0-27.2-19.2-37.2-37.2-37.2h-228c-18,0-37.2,9.6-37.2,37.2v60.4v0.4
                c-18,2-35.2,14-35.2,41.6v47.2c0,8,6.4,14.4,14.4,14.4h4.8V299c0,8,6.4,14.4,14.4,14.4h13.6c8,0,14.4-6.4,14.4-14.4v-37.6h250.8
                V299c0,8,6.4,14.4,14.4,14.4h13.6c8,0,14.4-6.4,14.4-14.4v-37.6h4.8c8,0,14.4-6.4,14.4-14.4v-46.8
                C372.8,172.6,355.6,160.6,337.6,158.6z M48.8,97.8h0.8C49.6,79,62,75,72.4,75h228c10.4,0,22.8,4,22.8,22.8v60.4h-10.8v-34.4
                c0-8-6.4-14.4-14.4-14.4h-88c-8,0-14.4,6.4-14.4,14.4v34.4h-16.8v-34.4c0-8-6.4-14.4-14.4-14.4h-88c-8,0-14.4,6.4-14.4,14.4v34.4
                H48.8V97.8z M298,123.8v34.4h-88v-34.4C210,123.8,298,123.8,298,123.8z M165.2,123.8v34.4h-88v-34.4
                C77.2,123.8,165.2,123.8,165.2,123.8z M46.8,299H33.2v-37.6h13.6C46.8,261.4,46.8,299,46.8,299z M339.6,299H326v-37.6h13.6V299z
                 M358.4,247.4h-18.8H326H46.8H33.2H14v-21.2h344.4V247.4z M358.4,211.8H14v-11.6c0-24,17.6-27.6,27.6-27.6h7.6h27.6h88H210h88
                h25.2h7.6c10.4,0,27.6,3.6,27.6,27.6L358.4,211.8L358.4,211.8z"/>
        </g>
    </g>
    </svg>
);
const Bathtub = ({size}) => (
<svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    className="bathtub-icon"
    style={{"enableBackground": "new 0 0 512 512", fill: "#2A2A2A"}}
>
<g transform="translate(1 1)">
	<g>
		<g>
			<path className="dim-icons" d="M485.4,272.1h-8.5V92.9c0-42.7-34.1-76.8-76.8-76.8c-37.8,0-64.9,28-68,69c-19.8,3.7-34.4,20.8-34.4,41.9
				c0,5.1,3.4,8.5,8.5,8.5h68.3c5.1,0,8.5-3.4,8.5-8.5c0-20.8-14.3-37.8-33.8-41.8c2.5-27.1,18.8-52.1,50.8-52.1
				c33.3,0,59.7,26.5,59.7,59.7v179.2H203c-3.9-19.7-20.9-34.1-41.8-34.1c-8.5-10.2-20.5-17.1-34.1-17.1c-16.2,0-30.7,9.4-37.5,23
				c-6.8-3.4-14.5-6-22.2-6c-21,0-38,14.5-41.8,34.1h-0.8C10.1,272.1-1,283.2-1,297.7c0,14.5,11.1,25.6,25.6,25.6h10.3l23,91.3
				c6.8,26.5,30.7,45.2,58,45.2h6.8L111.6,482c-2.6,4.3-0.9,9.4,3.4,11.1c0.9,0.9,2.6,0.9,3.4,0.9c3.4,0,6-1.7,7.7-4.3l14.9-29.9
				h236.8l14.5,29c1.7,3.4,4.3,5.1,7.7,5.1c1.7,0,2.6,0,3.4-1.7c3.4-1.7,5.1-6.8,3.4-11.1l-10.7-21.4c26.4-0.9,49.3-19.4,55.9-44.3
				l23.2-92.2h10c14.5,0,25.6-11.1,25.6-25.6C511,283.2,499.9,272.1,485.4,272.1z M365.1,118.5h-48.6c3.4-10.2,13.7-17.1,24.7-17.1
				S361.7,108.2,365.1,118.5z M67.3,255c7.7,0,14.5,3.4,20.5,9.4c1.7,2.6,5.1,3.4,8.5,2.6s5.1-3.4,6-6.8
				c2.6-12.8,12.8-22.2,25.6-22.2c9.4,0,17.9,4.3,22.2,12.8c1.7,3.4,6,5.1,9.4,4.3c0.9,0,1.7,0,2.6,0c11.1,0,20.5,6.8,23.9,17.1
				H43.4C46.8,261.8,56.2,255,67.3,255z M436.8,410.3c-5.1,18.8-22.2,32.4-41.8,32.4H116.8c-19.6,0-36.7-13.7-41.8-32.4l-22.2-87
				h404.5L436.8,410.3z M485.4,306.2h-17.1H41.7H24.6c-5.1,0-8.5-3.4-8.5-8.5s3.4-8.5,8.5-8.5h8.5h162.1h290.1
				c5.1,0,8.5,3.4,8.5,8.5S490.5,306.2,485.4,306.2z"/>
		</g>
	</g>
</g>
</svg>

)

const House = ({viewBox}) => (
<svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="-800 -50 2100 600"
    style={{"enableBackground": "new 0 0 499.6 499.6", "fill": "#2A2A2A"}}
>
<g>
    <g>
        <g>
            <path className="st0" d="M499.6,217.8v-120h-72v-48h16v-48h-128v48h16v48H212l-32.3-17L0,170.6l7.2,14.3l12.4-6.2V223l16-8.4v235.2
                h-32v48h496v-48h-16v-232H499.6z M331.6,17.8h96v16h-96V17.8z M411.6,49.8v48h-64v-48C347.6,49.8,411.6,49.8,411.6,49.8z
                 M483.6,113.8v48h-150l-91.2-48C242.4,113.8,483.6,113.8,483.6,113.8z M467.6,217.8v232h-144V214.6l6,3.2H467.6z M35.6,170.7
                l143.9-72l144.1,75.8v21.9l-144-75.8l-144,75.8L35.6,170.7L35.6,170.7z M107.6,289.8v160h-56V206.2l128-67.4l128,67.4v243.6h-56
                v-160H107.6z M235.6,305.8v144h-48v-144H235.6z M171.6,305.8v144h-48v-144H171.6z M483.6,481.8h-464v-16h88h144h232V481.8z
                 M339.6,201.8v-24h144v24H339.6z"/>
            <path className="st0" d="M131.6,273.8h96v-96h-96V273.8z M187.6,193.8h24v24h-24V193.8z M187.6,233.8h24v24h-24V233.8z M147.6,193.8
                h24v24h-24V193.8z M147.6,233.8h24v24h-24V233.8z"/>
            <path className="st0" d="M443.6,233.8h-96v136h96V233.8z M427.6,353.8h-64v-16h64V353.8z M427.6,321.8h-64v-72h64V321.8z"/>
            <rect x="347.6" y="385.8" className="st0" width="96" height="16"/>
        </g>
    </g>
</g>
</svg>
)

const Heart = ({filled}) => (
<svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
	viewBox="0 0 471.7 471.7"
	style={{"enableBackground": "new 0 0 471.7 471.7"}}
	className={filled && "filled"}
>
<g>
	<path className="st0" d="M444.7,159.4c0-27.7-10.7-53.7-30.3-73.3c-19.6-19.5-45.6-30.3-73.2-30.3c-27.6,0-53.7,10.8-73.3,30.4
		l-22.4,22.4c-5.3,5.3-13.8,5.3-19.1,0L203.8,86c-19.6-19.6-45.7-30.4-73.4-30.4c-27.6,0-53.6,10.8-73.1,30.3
		C37.7,105.4,27,131.4,27,159.1s10.8,53.7,30.4,73.3l178.3,178.3l178.7-178C434,213.1,444.8,187.1,444.7,159.4z"/>
	<path className="st1" d="M433.4,251.8c24.7-24.7,38.3-57.5,38.3-92.4c0.1-34.9-13.4-67.7-38.1-92.4c-24.7-24.7-57.4-38.2-92.3-38.2
		c-34.9,0-67.7,13.6-92.4,38.3L236,80l-13.1-13.1c-24.7-24.7-57.6-38.4-92.5-38.4c-34.8,0-67.6,13.6-92.2,38.2
		C13.5,91.4-0.1,124.2,0,159.1c0,34.9,13.7,67.6,38.4,92.3l187.8,187.8c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-3.9L433.4,251.8z
		 M235.7,410.7L57.4,232.4C37.8,212.8,27,186.8,27,159.1s10.7-53.7,30.3-73.2c19.5-19.5,45.5-30.3,73.1-30.3
		c27.7,0,53.8,10.8,73.4,30.4l22.6,22.6c5.3,5.3,13.8,5.3,19.1,0l22.4-22.4c19.6-19.6,45.7-30.4,73.3-30.4
		c27.6,0,53.6,10.8,73.2,30.3c19.6,19.6,30.3,45.6,30.3,73.3c0.1,27.7-10.7,53.7-30.3,73.3L235.7,410.7z"/>
</g>
</svg>
)

const ExitLeft = () => (
<svg
	version="1.1"
	id="exit-left"
	xmlns="http://www.w3.org/2000/svg"
	x="0px"
	y="0px"
	viewBox="0 0 231 175.5"
	style={{"enableBackground": "new 0 0 231 175.5"}}
>
<g>
    <path id="SVGID_1_" d="M73.1,93.5l24.8,24.8c2.3,2.3,2.3,5.9,0,8.2c-2.3,2.3-5.9,2.3-8.2,0L55,91.9c-2.3-2.3-2.3-5.9,0-8.2
        L89.7,49c2.3-2.3,5.9-2.3,8.2,0c2.3,2.3,2.3,5.9,0,8.2L73.1,82h97.7c3.8,0,6.9,2.6,6.9,5.8s-3.1,5.8-6.9,5.8H73.1z"/>
</g>
</svg>
)

const Close = () => (
<svg
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"

>
    <g id="Style-Guide" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.9">
        <g id="Media" transform="translate(-474.000000, -362.000000)">
            <g id="close" transform="translate(474.000000, 362.000000)">
                <g id="Sig-/-Preview-Inactive-Copy">
                    <rect id="Rectangle-4-Copy-4" fill="#E3E3E3" x="0" y="0" width="48" height="48" rx="3"></rect>
                    <g id="Group-4" transform="translate(7.680000, 7.680000)" fill="#4A4A4A">
                        <g id="Group-3">
                            <g id="Group-2" transform="translate(16.320000, 16.320000) rotate(-45.000000) translate(-16.320000, -16.320000) translate(5.760000, 5.760000)">
                                <rect id="Rectangle-5" x="9.6" y="0" width="1.92" height="21.12"></rect>
                                <rect id="Rectangle-5" transform="translate(10.560000, 10.560000) rotate(-90.000000) translate(-10.560000, -10.560000) " x="9.6" y="0" width="1.92" height="21.12"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>)

const Share = () => (
<svg
    version="1.1"
    id="share-icon"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
	viewBox="0 0 39.3 48"
	style={{"enableBackground":"new 0 0 39.3 48"}}
>
{/*<style type="text/css">
	.st0{clip-path:url(#SVGID_2_);}
	.st1{clip-path:url(#SVGID_4_);enable-background:new    ;}
	.st2{clip-path:url(#SVGID_6_);}
	.st3{clip-path:url(#SVGID_8_);fill:#0078FF;}
</style>*/}
<g>
    <path id="SVGID_1_" d="M0,24c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v17.5c0,1.2,1,2.2,2.2,2.2h26.2c1.2,0,2.2-1,2.2-2.2V24
        c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2v17.5c0,3.6-2.9,6.5-6.5,6.5H6.5C2.9,48,0,45.1,0,41.5V24z M21.8,7.4v23.1
        c0,1.2-1,2.2-2.2,2.2c-1.2,0-2.2-1-2.2-2.2V7.4l-5,5c-0.9,0.9-2.2,0.9-3.1,0c-0.9-0.9-0.9-2.2,0-3.1l8.7-8.7
        c0.9-0.9,2.2-0.9,3.1,0l8.7,8.7c0.9,0.9,0.9,2.2,0,3.1c-0.9,0.9-2.2,0.9-3.1,0L21.8,7.4z"/>
</g>
</svg>
)
const Pin = () => (
<svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
	viewBox="0 0 18.1 25.1"
	style={{enableBackground:"new 0 0 18.1 25.1"}}
	className="map-pin-link"
>
{/*<style type="text/css">
	.st0{clip-path:url(#SVGID_2_);}
	.st1{clip-path:url(#SVGID_4_);fill:#DD6372;}
</style>*/}
<g>
    <path id="SVGID_1_" d="M9.1,13c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6C5.4,11.3,7.1,13,9.1,13z M9.1,25.1
    c0,0.1-9.1-11-9.1-16S4.1,0,9.1,0s9.1,4.1,9.1,9.1S9.1,24.9,9.1,25.1z"/>
	<g className="clear-box">
        <rect id="SVGID_3_" x="-274.5" y="-711" width="1280" height="3870"/>
		<rect x="-5" y="-5" className="st1" width="28.1" height="35.1"/>
	</g>
</g>
</svg>

)
//const ImageImage = () => (
//)
const Facebook = () => (
<svg id="icon-facebook" width="48" height="48" viewBox="0 0 48 48" x="64" y="0">
<path fill="#3b5998" d="M47.519 24.114c0 13.051-10.58 23.631-23.63 23.631s-23.631-10.58-23.631-23.631 10.58-23.631 23.631-23.631c13.051 0 23.63 10.58 23.63 23.631z"></path>
<path fill="#fff" d="M28.25 47.744v-18.074h6.067l0.908-7.044h-6.975v-4.497c0-2.039 0.566-3.429 3.49-3.429l3.73-0.002v-6.3c-0.646-0.086-2.859-0.278-5.435-0.278-5.378 0-9.060 3.283-9.060 9.311v5.195h-6.082v7.044h6.082v18.074h7.274z"></path>
</svg>
)
const Twitter = () => (
<svg id="icon-Twitter" width="48" height="48" viewBox="0 0 48 48" x="576" y="0">
<path fill="#55acee" d="M47.392 24.233c0 13.051-10.58 23.631-23.631 23.631s-23.631-10.58-23.631-23.631c0-13.051 10.58-23.631 23.631-23.631s23.631 10.58 23.631 23.631z"></path>
<path fill="#fff" d="M43.124 14.875c-1.306 0.58-2.711 0.971-4.185 1.147 1.505-0.901 2.66-2.329 3.204-4.031-1.408 0.835-2.967 1.441-4.627 1.768-1.329-1.416-3.223-2.301-5.319-2.301-4.024 0-7.286 3.263-7.286 7.286 0 0.571 0.064 1.127 0.188 1.661-6.056-0.304-11.425-3.205-15.019-7.613-0.627 1.076-0.986 2.328-0.986 3.664 0 2.528 1.286 4.758 3.242 6.065-1.195-0.038-2.318-0.366-3.301-0.912-0.001 0.031-0.001 0.061-0.001 0.092 0 3.53 2.512 6.475 5.845 7.145-0.612 0.166-1.255 0.256-1.92 0.256-0.469 0-0.926-0.046-1.371-0.131 0.927 2.895 3.618 5.001 6.806 5.060-2.493 1.954-5.635 3.119-9.049 3.119-0.588 0-1.169-0.034-1.738-0.101 3.225 2.067 7.055 3.274 11.17 3.274 13.403 0 20.732-11.103 20.732-20.732 0-0.316-0.008-0.63-0.021-0.943 1.424-1.028 2.659-2.311 3.636-3.772z"></path>
</svg>
)
const Email = () => (
<svg id="icon-email" width="48" height="48" viewBox="0 0 48 48" x="0" y="0">
<path fill="#333" d="M48 24c0 13.255-10.745 24-24 24s-24-10.745-24-24c0-13.255 10.745-24 24-24s24 10.745 24 24z"></path>
<path fill="#fff" d="M6.219 13.225h34.901v21.55h-34.901v-21.55z"></path>
<path fill="#fff" d="M23.67 28.001c-0.217 0-0.434-0.071-0.615-0.213l-17.45-13.777c-0.334-0.264-0.464-0.71-0.326-1.113s0.516-0.673 0.94-0.673h34.901c0.424 0 0.802 0.27 0.94 0.673s0.008 0.849-0.326 1.113l-17.45 13.777c-0.18 0.142-0.398 0.213-0.615 0.213z"></path>
<path fill="#333" d="M41.12 13.225l-17.45 13.777-17.451-13.777h34.901zM41.12 11.226h-34.901c-0.848 0-1.603 0.54-1.88 1.345s-0.016 1.699 0.651 2.225l17.45 13.777c0.361 0.285 0.795 0.427 1.229 0.427s0.868-0.143 1.229-0.427l17.451-13.777c0.666-0.526 0.928-1.42 0.651-2.225s-1.032-1.345-1.88-1.345z"></path>
</svg>
)
const Embed = () => (
<svg id="icon-embed" width="48" height="48" viewBox="0 0 48 48" x="768" y="0">
<path fill="#333" d="M48 24c0 13.255-10.745 24-24 24s-24-10.745-24-24c0-13.255 10.745-24 24-24s24 10.745 24 24z"></path>
<path fill="#fff" d="M9.75 24.034l4.532-6.784h2.999l-4.534 6.784 4.534 6.731h-2.999l-4.531-6.731z"></path>
<path fill="#fff" d="M19.491 33.028l6.027-18.025h2.983l-5.968 18.025h-3.043z"></path>
<path fill="#fff" d="M38.28 24.034l-4.532-6.784h-2.999l4.534 6.784-4.534 6.731h2.999l4.532-6.731z"></path>
</svg>
)
const DropdownCaret = () => (
    <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-19bqh2r">
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
    </svg>
)
const MagnifyingGlass = () => (
    <svg height="20" width="20" viewBox="0 0 20 20">
        <path d="M17.545 15.467l-3.779-3.779a6.15 6.15 0 0 0 .898-3.21c0-3.417-2.961-6.377-6.378-6.377A6.185 6.185 0 0 0 2.1 8.287c0 3.416 2.961 6.377 6.377 6.377a6.15 6.15 0 0 0 3.115-.844l3.799 3.801a.953.953 0 0 0 1.346 0l.943-.943c.371-.371.236-.84-.135-1.211zM4.004 8.287a4.282 4.282 0 0 1 4.282-4.283c2.366 0 4.474 2.107 4.474 4.474a4.284 4.284 0 0 1-4.283 4.283c-2.366-.001-4.473-2.109-4.473-4.474z" fill="#CCCCCC" />
    </svg>
)
const ArrowDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50">
        <path d="M 24.78125 7.96875 A 2.0002 2.0002 0 0 0 23 10 L 23 35.09375 L 16.40625 28.5625 A 2.0002 2.0002 0 0 0 14.96875 27.96875 A 2.0002 2.0002 0 0 0 13.59375 31.4375 L 23.59375 41.3125 L 25 42.71875 L 26.40625 41.3125 L 36.40625 31.4375 A 2.0109563 2.0109563 0 1 0 33.59375 28.5625 L 27 35.09375 L 27 10 A 2.0002 2.0002 0 0 0 24.96875 7.96875 A 2.0002 2.0002 0 0 0 24.78125 7.96875 z" overflow="visible" enableBackground="accumulate" font-family="Bitstream Vera Sans"/>
    </svg>
)
const ArrowUp = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 50 50">
        <path d="M 25 7.21875 L 23.59375 8.65625 L 13.6875 18.53125 A 2.0108349 2.0108349 0 0 0 16.53125 21.375 L 23 14.875 L 23 40 A 2.0002 2.0002 0 1 0 27 40 L 27 14.875 L 33.46875 21.375 A 2.0108349 2.0108349 0 0 0 36.3125 18.53125 L 26.40625 8.65625 L 25 7.21875 z" overflow="visible" enableBackground="accumulate" font-family="Bitstream Vera Sans"/>
    </svg>
)
export { Bed, Tape, Bathtub, House, Heart, ExitLeft, Close, Share, Pin, Facebook, Twitter, Email, Embed, DropdownCaret, MagnifyingGlass, ArrowDown, ArrowUp };
